import React, { useState } from "react";

import { ContainerContent } from "@/components/Common/Dashboard/ContainerContent";
import { ContainerTitle } from "@/components/Common/Dashboard/ContainerTitle";
import { patientRequests } from "@/api/(requests)/patient";

import PatientProfileDetailsCard from "./PatientProfileDetailsCard";

const Notifications = (props) => {
  const [profileData, setProfileData] = useState(props.profileData);

  const SMSToggleSubmitHandler = () => {
    const clonedProfileData = structuredClone(profileData);

    clonedProfileData["preferences"]["is_sms_enabled"] =
      !clonedProfileData["preferences"]["is_sms_enabled"];

    patientRequests
      .update_preferences(clonedProfileData["preferences"])
      .then(() => {
        setProfileData(clonedProfileData);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const emailNotificationToggleSubmitHandler = (type) => {
    const clonedProfileData = structuredClone(profileData);
    const newValue = !clonedProfileData["preferences"]["email_subscriptions"][type];
    const data = {};

    data[type] = newValue;
    patientRequests
      .update_email_preferences(data)
      .then((response) => {
        if (response) {
          setProfileData(response);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const isSMSEnabled = profileData?.preferences?.is_sms_enabled ?? false;
  const sessionUpdates = profileData?.preferences?.email_subscriptions?.session_updates ?? false;
  const marketingCommunications =
    profileData?.preferences?.email_subscriptions?.marketing_communications ?? false;

  return (
    <ContainerContent data-public="true">
      <ContainerTitle title="Notifications" />

      {profileData && (
        <>
          <PatientProfileDetailsCard heading="Account Updates" type="Required">
            <div className="fs-14 d-flex flex-column mt-2 mb-4">
              <span>
                Receive important email notices about your aptihealth account and services.
              </span>
            </div>
          </PatientProfileDetailsCard>

          <PatientProfileDetailsCard
            heading="Session Update"
            onclick={() => emailNotificationToggleSubmitHandler("session_updates")}
            selected={sessionUpdates}
            testId="SessionUpdateNotificationsToggle"
            type="Toggle"
          >
            <div className="fs-14 d-flex flex-column mt-2 mb-4">
              <span>
                Receive email notices about your appointments, including confirmations, reminders,
                and cancellations.
              </span>
            </div>
          </PatientProfileDetailsCard>

          <PatientProfileDetailsCard
            heading="Marketing Communications"
            onclick={() => emailNotificationToggleSubmitHandler("marketing_communications")}
            selected={marketingCommunications}
            testId="MarketingCommunicationNotificationsToggle"
            type="Toggle"
          >
            <div className="fs-14 d-flex flex-column mt-2 mb-4">
              <span>
                Receive emails that highlight features of the aptihealth platform, our behavioral
                healthcare services, and
              </span>
              <span>the benefits of care.</span>
            </div>
          </PatientProfileDetailsCard>

          <PatientProfileDetailsCard
            heading="SMS Notifications"
            onclick={SMSToggleSubmitHandler}
            selected={isSMSEnabled}
            type="Toggle"
          >
            <div className="fs-14 d-flex flex-column mt-2 mb-4">
              <span>
                Receive important text messages about your appointments and in-app messages from
                your care team.
              </span>
              <span>We recommend enabling SMS to receive notices faster.</span>
            </div>
          </PatientProfileDetailsCard>
        </>
      )}
    </ContainerContent>
  );
};

export default Notifications;
